import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { LanguageProvider } from './i18n/LanguageContext';
import Landing from './pages/Landing';
import Activation from './pages/Activation';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import PoweredByBadge from './components/landing/PoweredByBadge';
import SupportFloat from './components/landing/SupportFloat';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // small delay so the destination page has mounted
      const id = hash.replace('#', '');
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/activation" element={<Activation />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        <PoweredByBadge />
        <SupportFloat />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
